import React from 'react';
import Link from 'gatsby-link';

import styled from 'styled-components';

// Components
import Search from '../../components/Search';

const PageWrapper = styled.section``;

const StandaloneSearchPage = () => {

  return (
    <PageWrapper>
      <h1>The Search Component</h1>
      <p>This component survives through the Gatsby build, it's loaded in the bundle as a React component.</p>
      <Search></Search>
    </PageWrapper>
  );
};

export default StandaloneSearchPage;



// WEBPACK FOOTER //
// ./src/pages/jamstack/search.js